const Files = [
    {
        brand: 'CATERPILLAR',
        model: '793-F',
        type: 'camion',
        group: 'camiones',
        files: [
            {
                name: 'Preview'
            }, /*
            {
                name: 'Preview_Con_Texturas'
            }, */
            {
                name: 'Cabina'
            },
            {
                name: 'Chasis'
            },
            /* {
                name: 'Eje'
            }, */
            {
                name: 'Estructura'
            },
            /* {
                name: 'Frenos'
            }, */
            {
                name: 'Maza'
            },
            {
                name: 'Motor'
            },
            {
                name: 'Neumaticos'
            },
            {
                name: 'Sistema_direccion'
            },
            {
                name: 'Sistema_hidraulico'
            },
            {
                name: 'Sistema_neumatico'
            },
            {
                name: 'Suspension'
            },
            {
                name: 'Transmision'
            }
        ]
    },
    {
        brand: 'KOMATSU',
        model: 'PC5500',
        type: 'pala',
        group: 'palas',
        files: [
            {
                name: 'Cabina'
            },
            {
                name: 'Chasis'
            },
            {
                name: 'Electrico'
            },
            {
                name: 'Estructura'
            },
            {
                name: 'Implemento'
            },
            {
                name: 'Mando_de_giro'
            },
            {
                name: 'Mando_final'
            },
            {
                name: 'Motor'
            },
            {
                name: 'Preview'
            },
            {
                name: 'PTO'
            },
            {
                name: 'Sistema_hidraulico'
            },
            {
                name: 'Sistema_rodado'
            }
        ]
    }
]

export default Files
